// Find icons here:
// https://iconsax-react.pages.dev/
// https://react-icons.github.io/react-icons

import {
  Activity,
  AddSquare,
  ArchiveBox,
  ArrangeHorizontalSquare,
  ArrowDown2,
  ArrowLeft2,
  ArrowRight,
  ArrowRight2,
  ArrowRotateLeft,
  ArrowRotateRight,
  ArrowSquareLeft,
  ArrowUp2,
  Briefcase,
  Calendar2,
  Chart2,
  Coffee,
  Command,
  Copy,
  Diagram,
  DocumentText1,
  Edit2,
  ExportCurve,
  ExportSquare,
  Eye,
  EyeSlash,
  GalleryImport,
  Gift,
  IconProps,
  Import,
  ImportSquare,
  InfoCircle,
  Judge,
  Kanban,
  LanguageSquare,
  Link,
  Link2,
  Link21,
  Lock1,
  LogoutCurve,
  Magicpen,
  Maximize1,
  Maximize3,
  MedalStar,
  Menu,
  MessageQuestion,
  MessageText1,
  Moon,
  More,
  MouseCircle,
  Note1,
  Notification,
  Play,
  Profile,
  Profile2User,
  Record,
  RecordCircle,
  RepeateMusic,
  Send,
  Setting2,
  Share,
  Shuffle,
  Sms,
  Star,
  Stop,
  Sun1,
  Task,
  TaskSquare,
  Trash,
  UserEdit,
  UserSquare,
  Video,
} from 'iconsax-react'
import React from 'react'
import { FaUsers } from 'react-icons/fa'
import { FiCheck, FiHelpCircle } from 'react-icons/fi'
import { IoSearchOutline } from 'react-icons/io5'

export const ArchiveIcon = ArchiveBox
export const AppsIcon = ArrangeHorizontalSquare
export const BackIcon = ArrowSquareLeft
export const CancelIcon = ArrowRotateLeft
export const CenterIcon = Maximize1
export const CheckIcon = FiCheck
export const ChecklistIcon = Task
export const ChevronDownIcon = ArrowDown2
export const ChevronLeftIcon = ArrowLeft2
export const ChevronRightIcon = ArrowRight2
export const ChevronUpIcon = ArrowUp2
export const CircleIcon = RecordCircle
export const CircleLinkIcon = Link2
export const CircleParentLinkIcon = Link
export const CopyIcon = Copy
export const CreateIcon = AddSquare
export const CurrentMemberIcon = UserSquare
export const DarkThemeIcon = Moon
export const DecisionIcon = Judge
export const DecisionsIcon = Judge
export const DeleteIcon = Trash
export const DownloadIcon = Import
export const EditIcon = Edit2
export const EmailIcon = Sms
export const ExportCircleIcon = GalleryImport
export const ExportIcon = ExportSquare
export const FileIcon = DocumentText1
export const HelpIcon = MessageQuestion
export const HideIcon = EyeSlash
export const ImportIcon = ImportSquare
export const IndicatorsIcon = Diagram
export const InfoTooltipIcon = FiHelpCircle
export const KanbanIcon = Kanban
export const LanguageIcon = LanguageSquare
export const LightThemeIcon = Sun1
export const LinkIcon = Link21
export const LogIcon = ArrowRotateLeft
export const LogoutIcon = LogoutCurve
export const LogsIcon = ArrowRotateLeft
export const MagicIcon = Magicpen
export const MarkUnreadIcon = EyeSlash
export const MaximizeIcon = Maximize3
export const MeetingAvatarIcon = FaUsers
export const MeetingIcon = Calendar2
export const MeetingRecurringIcon = RepeateMusic
export const MeetingsIcon = Calendar2
export const MemberIcon = Profile
export const MembersIcon = Profile2User
export const MenuIcon = Menu
export const MoreIcon = More
export const MoveIcon = ArrowRight
export const NewsIcon = Activity
export const NoteIcon = Note1
export const NotificationIcon = Notification
export const OrgChartIcon = MouseCircle
export const PlayIcon = Play
export const PollIcon = Chart2
export const PrivacyIcon = Lock1
export const RandomIcon = Shuffle
export const RestoreIcon = ArchiveBox
export const RoleIcon = Record
export const RotateLeftIcon = ArrowRotateLeft
export const RotateRightIcon = ArrowRotateRight
export const SearchIcon = (props: IconProps) => (
  <IoSearchOutline size={props.size || 24} />
)
export const SendIcon = Send
export const SettingsIcon = Setting2
export const ShareIcon = Share
export const ShortcutsIcon = Command
export const ShowIcon = Eye
export const StopIcon = Stop
export const SubscriptionIcon = Star
export const SubscriptionPlanBusiness = Briefcase
export const SubscriptionPlanFree = Gift
export const SubscriptionPlanStartup = Coffee
export const TaskIcon = TaskSquare
export const TasksIcon = TaskSquare
export const TasksListIcon = Task
export const ThreadIcon = MessageText1
export const ThreadsIcon = MessageText1
export const UploadIcon = ExportCurve
export const UserInfoIcon = UserEdit
export const VacantCircle = InfoCircle
export const VisioIcon = Video
export const SuperAdminIcon = MedalStar
